import { render, staticRenderFns } from "./InquiryDetail.vue?vue&type=template&id=7e0c7c71&scoped=true"
import script from "./InquiryDetail.vue?vue&type=script&lang=js"
export * from "./InquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./InquiryDetail.vue?vue&type=style&index=0&id=7e0c7c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0c7c71",
  null
  
)

export default component.exports